import React from "react";
import Router from "routes/router";
import "./App.scss";
import "antd/dist/antd.min.css";

const App = () => {
	return (
		<div className="App">
			<Router />
		</div>
	);
};

export default App;
